/* eslint-disable */
import Icon from 'acud-icon';
import React from 'react';

const barEmptySvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50"><g fill="none" fill-rule="evenodd"><path d="M-11-11h72v72h-72z"/><path fill="#D4D6D9" stroke="#D4D6D9" stroke-linejoin="round" stroke-width="2" d="M1 1h8v48H1z"/><path fill="#E8E9EB" stroke="#E8E9EB" stroke-linejoin="round" stroke-width="2" d="M21 15h8v34h-8zm20 16h8v18h-8z"/><path d="M-11-11h72v72h-72z"/></g></svg>
);
export default (props: {
    width?: number;
    height?: number
}) => {
    const {width, height} = props;
    return <Icon {...{width, height}} component={barEmptySvg} />;
}